var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgFeedback = function SvgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.278 7.066l8.25-4.95a.917.917 0 01.944 0l8.25 4.95a.917.917 0 01.445.786V19.25c0 .506-.41.917-.917.917H2.75a.917.917 0 01-.917-.917V7.852c0-.322.17-.62.445-.786zm1.389 2.977v8.29h14.666v-8.29l-6.796 4.908a.917.917 0 01-1.074 0l-6.796-4.908zm.446-1.94L11 13.079l6.887-4.974L11 3.97 4.113 8.104zm4.94.605a.917.917 0 01-.969-1.557l2.432-1.513a.917.917 0 01.97.001l2.427 1.517a.917.917 0 01-.972 1.555l-1.024-.64V11a.917.917 0 01-1.834 0V8.066l-1.03.642z"
  })));
};

export default SvgFeedback;